import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'glamorous';
import FetchTiles from '../../../../common/components/FetchTiles';
import LandingView from '../../../../common/components/LandingView';
import { TileViewTypes } from '../../../../common/components/TileView';
import LoadingView from '../../../../common/components/LoadingView';
import { TitleBar } from '../../../../common/components/Layout/StandardPageTemplate/Context';
import {
  MembershipType,
  MembershipStatus,
} from '../../../../common/option-lists';

const accountImageResolver = ({ imageUrl }) => {
  return imageUrl ? require(`../../assets/images/${imageUrl}`) : null;
};

const MembershipIdSubtitle = ({ id }, { activateMemberhipCard }) => {
  return (
    <span style={{ cursor: 'pointer' }} onClick={activateMemberhipCard}>
      Member # {id}
    </span>
  );
};
MembershipIdSubtitle.propTypes = {
  id: PropTypes.number,
};
MembershipIdSubtitle.contextTypes = {
  activateMemberhipCard: PropTypes.func,
};

export class HomePage extends React.Component {
  static propTypes = {
    currentUser: PropTypes.shape({
      id: PropTypes.string,
      token: PropTypes.string,
      settings: PropTypes.object,
      type: PropTypes.string,
    }),
    currentCustomer: PropTypes.object,
    currentOrganization: PropTypes.object,
  };

  currentUserIsMember = () => {
    const { currentUser, currentOrganization } = this.props;
    if (currentUser && currentUser.type === 'PrimaryContact') {
      if (currentOrganization && currentOrganization.id) {
        const { membershipDetails } = currentOrganization;
        if (
          membershipDetails.type === MembershipType.Member &&
          membershipDetails.statusType !== MembershipStatus.None
        ) {
          return true;
        }
      }
    }
    return false;
  };

  getSubtitle = () => {
    const { currentOrganization } = this.props;
    return <MembershipIdSubtitle id={(currentOrganization || {}).id || ''} />;
  };

  getIconColor = ({ color }) => this.props.theme.colors[color] || color;

  render() {
    return (
      <div>
        <TitleBar
          title="Account Management"
          subtitle={this.currentUserIsMember() ? this.getSubtitle : null}
        />
        <FetchTiles
          name="account"
          imageResolver={accountImageResolver}
        >
          {tiles =>
            !tiles || tiles.length === 0 ? (
              <LoadingView />
            ) : (
              <LandingView
                currentUser={this.props.currentUser}
                tiles={tiles}
                viewType={TileViewTypes.list}
                style={{ justifyContent: 'center' }}
              />
            )}
        </FetchTiles>
      </div>
    );
  }
}

export default withTheme(HomePage);



// WEBPACK FOOTER //
// ./src/App/account/components/LandingPage/index.js